import classnames from 'classnames';
import { useMemo } from 'react';
import styles from "./styles.module.scss";

export default ({
    relative,
    col,
    reverse,
    maxWidth,
    flex,
    spaceBetween,
    spaceAround,
    flexEnd,
    alignEnd,
    className,
    fitContent,
    alignCenter,
    justifyCenter,
    center,
    scrollY,
    column,
    bl1,
    span,
    absolute,
    bottom,
    mt3,
    pb3,
    b1grey,
    br1,
    p1,
    pr3,
    p3,
    pHalf,
    bt1grey,
    maxHeight,
    flexStart,
    fso72,
    fixed,
    shadow,
    lightShadow,
    deepShadow,
    mb1,
    ml1,
    ml3,
    mb3,
    fs75,
    fs90,
    fs150,
    fs120,
    italic,
    bold,
    borderless,
    mt1,
    grey,
    grey90,
    grey50,
    underline,
}) => useMemo(() => classnames({
    [styles.relative]: relative,
    [styles.flex]: flex,
    [styles.maxWidth]: maxWidth,
    [styles.reverse]: reverse,
    [styles.center]: center,
    [styles.alignCenter]: alignCenter,
    [styles.column]: column ?? col,
    [styles.spaceBetween]: spaceBetween,
    [styles.spaceAround]: spaceAround,
    [styles.span]: span,
    [styles.flexEnd]: flexEnd,
    [styles.flexStart]: flexStart,
    [styles.fitContent]: fitContent,
    [styles.absolute]: absolute,
    [styles.bottom]: bottom,
    [styles.mt3]: mt3,
    [styles.mt1]: mt1,
    [styles.ml1]: ml1,
    [styles.ml3]: ml3,
    [styles.pb3]: pb3,
    [styles.b1grey]: b1grey,
    [styles.br1]: br1,
    [styles.p3]: p3,
    [styles.p1]: p1,
    [styles.pr3]: pr3,
    [styles.pHalf]: pHalf,
    [styles.scrollY]: scrollY,
    [styles.bt1grey]: bt1grey,
    [styles.bl1]: bl1,
    [styles.alignEnd]: alignEnd,
    [styles.maxHeight]: maxHeight,
    [styles.fso72]: fso72,
    [className]: className,
    [styles.fixed]: fixed,
    [styles.shadow]: shadow,
    [styles.lightShadow]: lightShadow,
    [styles.deepShadow]: deepShadow,
    [styles.mb1]: mb1,
    [styles.mb3]: mb3,
    [styles.fs75]: fs75,
    [styles.fs90]: fs90,
    [styles.fs150]: fs150,
    [styles.fs120]: fs120,
    [styles.italic]: italic,
    [styles.bold]: bold,
    [styles.borderless]: borderless,
    [styles.grey]: grey,
    [styles.grey50]: grey50,
    [styles.grey90]: grey90,
    [styles.underline]: underline,
    [styles.justifyCenter]: justifyCenter,
}), [
    relative,
    col,
    maxWidth,
    flex,
    spaceBetween,
    spaceAround,
    flexEnd,
    className,
    fitContent,
    alignCenter,
    center,
    scrollY,
    column,
    bl1,
    span,
    absolute,
    bottom,
    mt3,
    pb3,
    b1grey,
    br1,
    p1,
    pr3,
    p3,
    pHalf,
    bt1grey,
    maxHeight,
    fso72,
    flexStart,
    deepShadow,
    shadow,
    lightShadow,
    mb1,
    mb3,
    fs75,
    fs90,
    fs150,
    fs120,
    italic,
    bold,
    borderless,
    mt1,
    ml1,
    ml3,
    grey,
    grey90,
    grey50,
    reverse,
    underline,
    justifyCenter
])
